import { Pipe, PipeTransform } from '@angular/core';
import { ListFilterModeAllowedValues } from '../components/whitelabel-apps-list/whitelabel-apps-list.component';
import { WhitelabelConfiguration } from '../models/whitelabel-config';

@Pipe({
  standalone: false,
  name: 'sortWhitelabelAppsByType'
})
export class SortWhitelabelAppsByTypePipe implements PipeTransform {

  transform(value: WhitelabelConfiguration[], mode: ListFilterModeAllowedValues): WhitelabelConfiguration[] {
    let configurations = value;

    if (mode === 'created') configurations = configurations.filter(c => !c.isDraft);
    if (mode === 'inDraft') configurations = configurations.filter(c => c.isDraft && c.isDraft === true);
    
    return configurations;
  }

}
